import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'

import { Setting } from './setting'

@InputType()
export class NewSetting {
  @Field()
  name: string

  @Field({ nullable: true })
  description?: string

  @Field()
  category: string

  @Field({ nullable: true })
  value?: string
}

@InputType()
export class SettingPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  category?: string

  @Field({ nullable: true })
  value?: string

  @Field({ nullable: true })
  cuFlag: string
}

@ObjectType()
export class SettingList {
  @Field(type => [Setting])
  items: Setting[]

  @Field(type => Int)
  total: number
}
